// extracted by mini-css-extract-plugin
export default {"container":"Panel_container__VXKLo","wrapper":"Panel_wrapper__teHj-","title":"Panel_title__4FgcL"};